import { render, staticRenderFns } from "./FormTraspaso.vue?vue&type=template&id=0a485a45&"
import script from "./FormTraspaso.vue?vue&type=script&lang=js&"
export * from "./FormTraspaso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports